// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import GalleryLanding from './pages/GalleryLanding';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

// Separate component for the app content to use the theme context
function AppContent() {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen fixed inset-0 w-full ${isDarkMode ? 'dark' : ''} 
      bg-gradient-to-br from-neutral-50 via-blue-50 to-neutral-100 
      dark:bg-gradient-to-br dark:from-neutral-900 dark:via-blue-950 dark:to-neutral-900 
      text-neutral-900 dark:text-white transition-colors duration-500 overflow-y-auto`}>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<GalleryLanding />} />
          <Route path="/gallery/:category" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;